import { ElementShowImages } from "../../../features/base/image/list/ElementShowImages";
import { ObjectTarget } from "../../../app/permissions";

interface SchoolImagesProps {
  schoolId: string;
  canDeleteImage: boolean;
}

const SchoolImages = (props: SchoolImagesProps) => {
  return <ElementShowImages
    request={{
      targetType: ObjectTarget.SCHOOL,
      targetId: props.schoolId,
    }}
    toolbar={{
      label: "Imagens",
    }}
    messages={{
      empty: "Não há imagens da escola",
      error: "Erro ao carregar imagens"
    }}
    schoolId={props.schoolId}
    canDelete={props.canDeleteImage}
  />;

};

export default SchoolImages;